// extracted by mini-css-extract-plugin
export var columnItem = "_b1-3";
export var columnItemDraggable = "_b1-4";
export var dragHandle = "_b1-0";
export var dragHandleHovered = "_b1-1";
export var dropdown = "_b1-5";
export var dropdownContent = "_b1-7";
export var dropdownInner = "_b1-6";
export var filterDropdownHeader = "_b1-8";
export var icon = "_b1-2";
export var sectionDivider = "_b1-9";